import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { withTranslation, WithTranslation } from "react-i18next";
import Loader from '../common/Loader';
import { DASHBOARD_URL } from '../../constants/config';
import { useAppSelector } from '../../store/hooks';

interface CustomerDashboardsOwnProps {
  selectedDashboards: string[];
  onDashboardToggle: (id: string) => void;
  className?: string;
  isLoading?: boolean;
}

const CustomerDashboards = (props: CustomerDashboardsOwnProps & WithTranslation) => {
  const { t } = props; // [t, i18n]
  const navigate = useNavigate();
  const dashboards = useAppSelector((store) => store.customer.dashboards);
  const [showDisabledDashboards, setShowDisabledDashboards] = useState(false);

  // Render all customer dashboards not disabled at the 1st time rendered.
  // - ticking 'Show disabled dashboards' rendered all.
  const renderDashboards = (selectedDashboards: string[], onDashboardToggle: (id: string) => void) => dashboards.map((dashboard, i) => {
    const _onDashboardToggle = () => onDashboardToggle(dashboard._id);
    return (
      <div key={i} style={{display: 'flex'}}>{dashboard.disabled}
        <div style={{display: (!dashboard.disabled || showDisabledDashboards) ? props.className : 'none'}}>
          <label style={{float: 'left'}}>
            <input
              type="checkbox"
              checked={selectedDashboards.includes(dashboard._id)}
              onChange={_onDashboardToggle} />
          </label>
          <button style={{visibility: 'hidden', background: 'white', marginRight: '0.5rem'}}
            key={i}
            onClick={() => navigate('/dashboard/' + dashboard._id)}>
            <i className="fa fa-users" aria-hidden="true" style={{opacity: 0.5}}></i>
          </button>
          <Link
            style={{float: 'left', color: dashboard.disabled ? 'grey' : 'green'}}
            to={`/dashboard/${dashboard._id}`}
            >{dashboard.name}
          </Link>
          <a style={{float:'left', marginLeft:'0.2rem', opacity: dashboard.disabled ? '0.5' : '1', color: dashboard.disabled ? 'grey' : 'green'}}
            // Update cache when opening dashboard
            href={`${DASHBOARD_URL}?hash=${dashboard._id}&cache=del`}
            title="Open dashboard"
            target="_blank"><i className="fa fa-external-link" aria-hidden="true"></i>
          </a>
        </div>
      </div>
    );
  });

  // Boolean toggle tickbox handler
  const handleShowDisabledCheckBox = (_event: React.ChangeEvent<HTMLInputElement>) => {
    setShowDisabledDashboards((prev) => !prev);
  };

  return (
    <div>
      <label>
        <input
          type="checkbox"
          onChange={handleShowDisabledCheckBox}
        />
        {t('dashboard.showDisabled')}
      </label>
      {props.isLoading && <Loader />}
      <div style={{height:"0.4em"}}></div>
      {renderDashboards(props.selectedDashboards, props.onDashboardToggle)}
    </div>
  );
};

// This component had CSSModules(CustomerDashboards) with NO styles map — which
// throws at runtime the moment a styleName renders. All styling is inline
// style={}, so the styleNames + CSSModules wrapper were dropped.
export default withTranslation('common')(CustomerDashboards);
